import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Videos from "@/components/landing/Videos";
import Bio from "@/components/landing/Bio";
import Gallery from "@/components/landing/Gallery";
import Dossier from "@/components/landing/Dossier";
import BookingForm from "@/components/landing/BookingForm";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main className="bg-[#09090D] text-zinc-100 overflow-x-clip">
      <div className="noise-overlay" />
      <Nav />
      <Hero />
      <Marquee />
      <Videos />
      <Bio />
      <Gallery />
      <Dossier />
      <BookingForm />
      <Footer />
    </main>
  );
}
